import { IBroker } from "@rentiohq/shared-frontend/dist/types/broker.types";

export interface IExtraData {
  broker: IBroker;
}

export enum EField {
  IntakeMail = "intakeMail",
  IntakeType = "intakeType",
}
